import { render, staticRenderFns } from "./ClientsSection.vue?vue&type=template&id=5cbc8074&"
import script from "./ClientsSection.vue?vue&type=script&lang=js&"
export * from "./ClientsSection.vue?vue&type=script&lang=js&"
import style0 from "./ClientsSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports